import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormControl, NgModel, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material';
import moment, { isMoment } from 'moment';

@Component({
    selector: 'input-date',
    templateUrl: './input.date.html',
    styleUrls: ['./input.scss'],
    providers: [
        { 
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => InputDate),
          multi: true
        }
      ],
      // changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputDate implements OnInit, OnChanges, ControlValueAccessor {

    value: Date | moment.Moment;

    date: Date | moment.Moment;

    @Input('name')
    name: string;

    @Input('label')
    label: string;

    @Input('hint')
    hint: string;

    @Input('error-message')
    errorMessage: string;

    @Input('required')
    required: boolean;

    @Input('hidden')
    hidden: boolean;

    @Input('disabled')
    disabled: boolean;

    @Input('readonly')
    readonly: boolean;

    @Input('validator')
    validator: (string) => string; 

    @Input('min')
    min: Date;

    @Input ('max')
    max: Date;

    error: string;

    // control: FormControl;

    ngOnInit() {
      // this.required = true;
      // this.control = new FormControl(this.value);

      // if (this.required) { this.control.setValidators([Validators.required]); }
      // if (this.disabled) { this.control.disable(); }
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    setDate(date: Date | moment.Moment) {
      if (!this.value) {
        this.value = date;
      }
      else {
        if (typeof(this.value) == 'string') this.value = moment(this.value);

        let year: number, month: number, day: number;
        if (moment.isMoment(date)) {
          year = date.year();
          month = date.month();
          day = date.date();
        } else {
          year = date.getFullYear();
          month = date.getMonth();
          day = date.getDate();
        }

        if (moment.isMoment(this.value)) {
          this.value.set('year', year).set('month', month).set('date', day);
        } else
          try {
            this.value.setFullYear(year);
            this.value.setMonth(month);
            this.value.setDate(day);
          } catch(jsError) {
        }
      }
      this.changeValue(this.value);
      // console.log("New start time:", this.event.ends);
    }
  
    getDate(): Date {
      if (!this.value) return null;

      if (moment.isMoment(this.value)) {
        return this.value.toDate();
      } else {
        return new Date(this.value);
      }
    }    

    readonly errorMatcher: ErrorStateMatcher = {
      isErrorState: (ctrl: FormControl) => {
          // (ctrl && ctrl.invalid)
          // this.error = null;
          // if (this.required && (!this.value || this.value.trim().length == 0)) {
          //     this.error = 'required';
          // }
          return !!this.error;
        }
    }

    changeValue(event: Date | moment.Moment) {
      // let src = new Date(event);
      // if (moment.isMoment(this.value)) {
      //   this.value.set('year', src.getFullYear()).set('month', src.getMonth()).set('date', src.getDate());
      // } else {
      //   if (this.value) {
      //     this.value.setFullYear(src.getFullYear(), src.getMonth(), src.getDate());
      //   } else {
      //     this.value = event;
      //   }
      // }
      if (moment.isMoment(event)) {
        this.value = moment(event);
        this.value.set('hour', event.get('hour')).set('minute', event.get('minute'));
      } else {
        this.value = new Date(event);
      }
      this.propagateChange(this.value);

      if (this.validator) {
        this.error = this.validator(this.value);
        return;
      }

      this.error = null;
      if (this.required && !event) {
        this.error = 'Value is required';
      }
    }

    writeValue(value: any) {
      // if (value !== undefined) {
        // if (value != this.value) {
          // this.changeValue(value);
        // }
        // if (typeof(value) == 'string') value = moment(value);
        this.value = value;
        this.date = this.getDate();
      // }
    }

    propagateChange = (_: any) => {};
    // propagateChange = (_: Date | moment.Moment) => {};

    registerOnChange(fn) {
      this.propagateChange = fn;
    }

    registerOnTouched() {}
}